import "./FailedRuleEdit.css";
import { useState, useEffect, useMemo } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import searchruleIcon from "../../../common/assets/images/searchrule.png";
import { useDispatch, useSelector } from "react-redux";
import { codeAssistRuleManagment, getRuleIDStatusRepsone, getTestRuleDetails} from "../TestRule/TestRuleRedux";
import { toast, ToastContainer } from "react-toastify";
import { Tooltip } from "@mui/material";
import { Spinner } from "react-bootstrap";
import {fetchPathwayOptions, fetchTriggerCodeOptions} from "../CreateNewRule/redux/CreateNewRuleSlicer";
import PublishStatusModal from "../PublishedRule/PublishStatusModal";

const PATHWAY_OPTIONS = [
  { value: "icd", label: "ICD Index" },
  { value: "achi", label: "ACHI Index" },
];


export default function FailedRuleEdit({ onCancel }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [searchParams] = useSearchParams();
  const ruleId = searchParams.get("code_assist_manual_rule_id");
  // const isEditPage = searchParams.get("isEditPage");

const isEditPage =
  searchParams.get("isEditPage") === "true";
  const [showPublishModal, setShowPublishModal] = useState(false);
  const [publishModalType, setPublishModalType] = useState("loading");
  const [ruleStatusResponse, setRuleStatusResponse] = useState(null);

  const {
    loading: testRuleDetailsLoading,
    data: testRuleDetailsData,
    error: testRuleDetailsError,
  } = useSelector((state) => state.testRule.testRuleDetails);

  const triggerCodeOptionsRaw = useSelector(
    (state) => state.createNewRule?.triggerCodeOptions,
  );

  const pathwayEntryOptionsRaw = useSelector(
    (state) => state.createNewRule?.pathwayOptions,
  );
  const pathwayEntryOptions = Array.isArray(pathwayEntryOptionsRaw)
    ? pathwayEntryOptionsRaw
    : [];


  const pathwayEntryLoading = useSelector(
    (state) => state.createNewRule?.pathwayEntryLoading,
  );

  const pathwayEntryHasMore = useSelector(
    (state) => state.createNewRule?.pathwayEntryHasMore,
  );
  const triggerCodeOptions = Array.isArray(triggerCodeOptionsRaw)
    ? triggerCodeOptionsRaw
    : [];

  const triggerCodeLoading = useSelector(
    (state) => state.createNewRule?.triggerCodeLoading,
  );

  const triggerCodeHasMore = useSelector(
    (state) => state.createNewRule?.triggerCodeHasMore,
  );

  const SEARCH_PAGE_SIZE = 10;
  const SCROLL_LOAD_MORE_THRESHOLD_PX = 50;

  const [description, setDescription] = useState("");
  const [triggerCodes, setTriggerCodes] = useState([]);
  const [configuredGuidance, setConfiguredGuidance] = useState("");
  const [recommendedAction, setRecommendedAction] = useState("");

  const [codeQuery, setCodeQuery] = useState("");
  const [codeOpen, setCodeOpen] = useState(false);
  const [codePage, setCodePage] = useState(1);

  const [pathwayEntity, setPathwayEntity] = useState("");
  const [pathwayQuery, setPathwayQuery] = useState("");
  const [pathwayOpen, setPathwayOpen] = useState(false);
  const [pathwayPage, setPathwayPage] = useState(1);
  const [pathwayType, setPathwayType] = useState("");
  const [descriptionError, setDescriptionError] = useState("");
  const [pathwayEntityError, setPathwayEntityError] = useState("");

  const filteredCodeSuggestions = useMemo(() => {
    const alreadySelected = new Set(triggerCodes.map((c) => c.code));

    return triggerCodeOptions.filter((c) => !alreadySelected.has(c.code));
  }, [triggerCodeOptions, triggerCodes]);

  const filteredPathwaySuggestions = useMemo(() => {
  return pathwayEntryOptions;
}, [pathwayEntryOptions]);

  useEffect(() => {
    if (!codeOpen) return undefined;

    const handle = setTimeout(() => {
      setCodePage(1);

      dispatch(
        fetchTriggerCodeOptions({
          search_code: codeQuery.trim(),
          search_description: null,
          page_number: 1,
          page_size: SEARCH_PAGE_SIZE,
        }),
      );
    }, 300);

    return () => clearTimeout(handle);
  }, [dispatch, codeQuery, codeOpen]);

useEffect(() => {
  if (!pathwayOpen || pathwayType === "") return undefined;

  const handle = setTimeout(() => {
    setPathwayPage(1);

    dispatch(
      fetchPathwayOptions({
        search_code: pathwayQuery.trim(),
        search_description: null,
        code_type: pathwayType,
        page_number: 1,
        page_size: SEARCH_PAGE_SIZE,
      })
    );
  }, 300);

  return () => clearTimeout(handle);
}, [
  dispatch,
  pathwayQuery,
  pathwayOpen,
  pathwayType,
]);

  function addCode(option) {
    setTriggerCodes((prev) => {
      if (prev.some((c) => c.code === option.code)) {
        return prev;
      }

      return [
        ...prev,
        {
          code: option.code,
          code_type: option.code_type || null,
          code_description: option.code_description || option.description || "",
        },
      ];
    });

    setCodeQuery("");
    setCodeOpen(false);
  }

  function removeCode(code) {
    setTriggerCodes((prev) => prev.filter((c) => c.code !== code));
  }


  function handleTriggerCodeSuggestionsScroll(e) {
    if (!triggerCodeHasMore || triggerCodeLoading) return;

    const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;

    if (
      scrollHeight - scrollTop - clientHeight >
      SCROLL_LOAD_MORE_THRESHOLD_PX
    ) {
      return;
    }

    const nextPage = codePage + 1;

    setCodePage(nextPage);

    dispatch(
      fetchTriggerCodeOptions({
        search_code: codeQuery.trim() || null,
        search_description: null,
        page_number: nextPage,
        page_size: SEARCH_PAGE_SIZE,
      }),
    );
  }

function handlePathwaySuggestionsScroll(e) {
  if (pathwayEntryLoading || !pathwayEntryHasMore) return;

  const {
    scrollTop,
    scrollHeight,
    clientHeight,
  } = e.currentTarget;

  if (
    scrollHeight - scrollTop - clientHeight >
    SCROLL_LOAD_MORE_THRESHOLD_PX
  ) {
    return;
  }

  const nextPage = pathwayPage + 1;

  setPathwayPage(nextPage);

  dispatch(
    fetchPathwayOptions({
      search_code: pathwayQuery.trim(),
      search_description: null,
      code_type: pathwayType,
      page_number: nextPage,
      page_size: SEARCH_PAGE_SIZE,
    })
  );
}
  useEffect(() => {
    const testRuleID = JSON.parse(
      sessionStorage.getItem("test-rule-id")
    );

    // if (!testRuleID || !ruleId) return;

    dispatch(
      getTestRuleDetails({
        code_assist_manual_rule_id: ruleId,
      })
    );
  }, [dispatch]);

  // Map API response into form state
  useEffect(() => {
    if (!testRuleDetailsData) return;

    setDescription(testRuleDetailsData.description || "");

    setTriggerCodes(testRuleDetailsData.trigger_codes || []);
    const pathwayEntryType = testRuleDetailsData.pathway_entry?.type || "";

  const nextPathwayType =
  pathwayEntryType === "ICD Index"
    ? "icd"
    : pathwayEntryType === "ACHI Index"
      ? "achi"
      : "";

  const nextPathwayEntity =
  testRuleDetailsData.pathway_entry?.value || "";

  setPathwayType(nextPathwayType);
  setPathwayEntity(nextPathwayEntity);
  setPathwayQuery("");
  setPathwayOpen(false);
  setPathwayPage(1);

    setConfiguredGuidance(
      testRuleDetailsData.guidance?.configured_guidance || ""
    );

    setRecommendedAction(
      testRuleDetailsData.guidance?.recommended_action || ""
    );
  }, [testRuleDetailsData]);

  const handleRemoveCode = (code) => {
    setTriggerCodes((prev) => prev.filter((item) => item.code !== code));
  };

  const handleAddCode = () => {
    const trimmed = codeInput.trim();
    if (trimmed && !triggerCodes.some((item) => item.code === trimmed)) {
      setTriggerCodes((prev) => [...prev,
        {
          code: trimmed,
          code_type: "ICD-10-AM",
          code_description: "",
        },
      ]);
    }
    setCodeInput("");
  };

  const handleCodeInputKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleAddCode();
    }
  };

  const handleCancel = () => {
    if (onCancel) return onCancel();
    navigate(-1);
  };

function handlePathwayTypeChange(e) {
  const selectedType = e.target.value;

  setPathwayType(selectedType);
  setPathwayEntity("");
  setPathwayQuery("");
  setPathwayPage(1);
  setPathwayOpen(false);
}
const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const showFailedResult = (message) => {
  setRuleStatusResponse({
    items: [{ status: "FAILED", error_message: message }],
  });
  setPublishModalType("result");
  setShowPublishModal(true);
};

const pollRuleStatus = async (jobId) => {
  if (!jobId) {
    showFailedResult("Job ID was not returned.");
    return;
  }

  while (true) {
    try {
      const result = await dispatch(getRuleIDStatusRepsone(jobId)).unwrap();
      const items = result?.items || [];

      const isCompleted =
        items.length > 0 &&
        items.every(
          (item) => item?.status === "COMPLETED" || item?.status === "FAILED"
        );

      if (isCompleted) {
        setRuleStatusResponse(result);
        setPublishModalType("result");
        setShowPublishModal(true);
        return;
      }

      await wait(5000);
    } catch (error) {
      console.error("Status API failed:", error);
      showFailedResult("Failed to fetch rule status");
      return;
    }
  }
};
const handleSaveAndTest = async () => {
  let hasError = false;

  // Clear previous errors
  setDescriptionError("");
  setPathwayEntityError("");

  // Validate Description
  if (!description.trim()) {
    setDescriptionError("Rule Description is required.");
    hasError = true;
  }

  // Validate Primary Entry Point
  if (!pathwayEntity.trim()) {
    setPathwayEntityError("Primary Entry Point is required.");
    hasError = true;
  }

  // Stop here — DO NOT call API
  if (hasError) {
    return;
  }

  const pathwayLabel =
    PATHWAY_OPTIONS.find(
      (option) => option.value === pathwayType
    )?.label || null;

  const updatedRule = {
    ...testRuleDetailsData,
    description: description.trim(),
    pathway_entry: pathwayType && pathwayEntity
      ? {
          ...testRuleDetailsData.pathway_entry,
          type: pathwayLabel,
          value: pathwayEntity,
        }
      : null,
    trigger_codes: triggerCodes,
    guidance: {
      ...testRuleDetailsData.guidance,
      configured_guidance: configuredGuidance,
      recommended_action: recommendedAction,
    },
    action: "SAVE_AND_TEST",
  };

  // show loading modal immediately
  setPublishModalType("loading");
  setRuleStatusResponse(null);
  setShowPublishModal(true);

  try {
    const response = await dispatch(
      codeAssistRuleManagment(updatedRule)
    ).unwrap();

    const jobId = response?.job_id;

    if (jobId) {
      await pollRuleStatus(jobId);
    } else {
      showFailedResult("Job ID was not returned.");
    }
  } catch (error) {
    setShowPublishModal(false);
    toast.error("Edit rule failed");
    console.error(error, "edit testRule error");
  }
};
const handlePathwaySelect = (option) => {
  const selectedCode = option.code || option.value || "";

  setPathwayEntity(selectedCode);
  setPathwayQuery("");
  setPathwayOpen(false);
  setPathwayEntityError("");
};

  if (testRuleDetailsLoading) {
    return <div className="editFailedRule-loading">Loading rule details...</div>;
  }

  // if (testRuleDetailsError) {
  //   return <div className="editFailedRule-error">Failed to load rule details.</div>;
  // }

  if (!testRuleDetailsData) {
    return null;
  }

  return (
    <div className="editFailedRule-page">
      <ToastContainer position="top-right" autoClose={3000} />
      <PublishStatusModal
        show={showPublishModal}
        type={publishModalType}
        environment={[]}
        resultItems={ruleStatusResponse?.items || []}
        title="Updating Rule"
        loadingTitle="Updating Your Rule"
        successTitle="Rule Updated Successfully"
        loadingMessage="Your rule is being updated and submitted for testing."
        successMessage="Your rule has been successfully updated and is ready for testing."
        loadingInfoMessage="Please do not close or refresh this page while we finish updating your rule."
        failedTitle="Rule Update Failed"
        failedMessage="We couldn't update your rule. Please try again."
        failedInfoMessage="Some items could not be updated. Please review the details and try again."
        onClose={() => {
          setShowPublishModal(false);

          const allCompleted =
            ruleStatusResponse?.items?.length > 0 &&
            ruleStatusResponse.items.every(
              (item) => item?.status === "COMPLETED",
            );

          if (publishModalType === "result" && allCompleted) {
            navigate("/test-rule-table");
          }
        }}
      />
      <div className="editRule-page-header">
        <span className="editRule-page-header-bar" aria-hidden="true" />
        <h1 className="editRule-page-title">Edit Rule</h1>
      </div>

      <div className="editFailedRule-card">
        {/* Status strip */}
        <div className="editFailedRule-statusStrip">
          <div className="editFailedRule-statusStrip-left">
            {testRuleDetailsLoading ? (
              "Loading..."
            ) : (
              <>
                <span className="editFailedRule-id-pill">
                  {testRuleDetailsData.rule_id}
                </span>
                <span
                  className={`editFailedRule-status-badge ${isEditPage ? "editFailedRule-status-badge--edit" : "editFailedRule-status-badge--failed"}`}
                >
                  {testRuleDetailsData.status?.toUpperCase()}
                </span>
              </>
            )}
          </div>
          <div className="editFailedRule-statusStrip-right">
            {testRuleDetailsLoading
              ? "Loading..."
              : `Editing Rule : ${testRuleDetailsData?.rule_id || "-"} | Current Status: ${testRuleDetailsData?.status || "-"}`}
          </div>
        </div>

        <div className="editFailedRule-body">
          {/* Rule Information */}
          <div className="editFailedRule-section">
            <div className="editFailedRule-section-header">
              Rule Information
            </div>
            <div className="editFailedRule-section-divider" />

            <label className="editFailedRule-label">
              Rule Description
              <span className="editFailedRule-required">*</span>
            </label>
            <textarea
              className={`editFailedRule-textarea ${
                descriptionError ? "editFailedRule-input-error" : ""
              }`}
              rows={2}
              value={description}
              onChange={(e) => {
                setDescription(e.target.value);

                if (e.target.value.trim()) {
                  setDescriptionError("");
                }
              }}
            />

            {descriptionError && (
              <div className="editFailedRule-field-error">
                {descriptionError}
              </div>
            )}
          </div>

          {/* Pathway Entry Point */}
          <div className="editFailedRule-section">
            <div style={{ display: "flex", alignItems: "baseline" }}>
              <div className="editFailedRule-section-header">
                Pathway Entry Point
              </div>
              <div className="failrule-section-heading-row">
                <select
                  className="editRule-pathway-select"
                  value={pathwayType}
                  disabled={testRuleDetailsLoading}
                  onChange={handlePathwayTypeChange}
                  aria-label="Pathway Entry Point type"
                >
                  <option value="" disabled hidden>
                    Select Pathway Entry Point
                  </option>

                  {PATHWAY_OPTIONS.map((opt) => (
                    <option key={opt.value} value={opt.value}>
                      {opt.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="editFailedRule-section-divider" />
            <label
              className="editFailedRule-label"
              htmlFor="pathway-entry-point"
            >
              Primary Entry Point
              <span className="editFailedRule-required">*</span>
            </label>
            <div className="editFailedRule-code-combobox">
              <input
                id="pathway-entry-point"
                type="text"
                autoComplete="off"
                className="editFailedRule-codeInput"
                placeholder={
                  pathwayType === ""
                    ? "Select a Pathway Entry Point type first..."
                    : "Type to search pathway entry..."
                }
                value={pathwayEntity || pathwayQuery}
                disabled={testRuleDetailsLoading || pathwayType === ""}
                onChange={(e) => {
                  setPathwayEntity("");
                  setPathwayQuery(e.target.value);
                  setPathwayOpen(true);
                }}
                onFocus={() => {
                  if (pathwayType !== "") {
                    setPathwayOpen(true);
                  }
                }}
                onBlur={() => setTimeout(() => setPathwayOpen(false), 120)}
              />

              {pathwayOpen && pathwayType !== "" && (
                <div
                  className="editFailedRule-suggestions"
                  onScroll={handlePathwaySuggestionsScroll}
                >
                  {pathwayEntryOptions.length === 0 && pathwayEntryLoading ? (
                    <div className="editFailedRule-suggestions-empty editFailedRule-suggestions-loading">
                      <Spinner animation="border" size="sm" className="me-2" />
                      Searching...
                    </div>
                  ) : pathwayEntryOptions.length === 0 ? (
                    <div className="editFailedRule-suggestions-empty">
                      No matching pathway entry points.
                    </div>
                  ) : (
                    <>
                      {pathwayEntryOptions.map((option) => (
                        <button
                          type="button"
                          key={`${option.code_type || option.type}-${option.code || option.value}`}
                          className="editFailedRule-suggestion-item"
                          onMouseDown={(e) => {
                            e.preventDefault();
                            handlePathwaySelect(option);
                          }}
                        >
                          <strong>{option.code || option.value}</strong>
                        </button>
                      ))}

                      {pathwayEntryLoading && (
                        <div className="editFailedRule-suggestions-empty editFailedRule-suggestions-loading">
                          <Spinner
                            animation="border"
                            size="sm"
                            className="me-2"
                          />
                          Loading more...
                        </div>
                      )}
                    </>
                  )}
                </div>
              )}
              {pathwayEntityError && (
                <div className="editFailedRule-field-error">
                  {pathwayEntityError}
                </div>
              )}
            </div>
          </div>

          {/* Trigger Codes */}
          <div className="editFailedRule-section">
            <div className="editFailedRule-section-header">Trigger Codes</div>
            <div className="editFailedRule-section-divider" />
            <label className="editFailedRule-label" htmlFor="trigger-codes">
              ICD-10 / ACHI Codes
            </label>

            <div className="editFailedRule-code-combobox">
              <input
                id="trigger-codes"
                type="text"
                autoComplete="off"
                className="editFailedRule-codeInput"
                placeholder="Type to search codes..."
                value={codeQuery}
                disabled={testRuleDetailsLoading}
                onChange={(e) => {
                  setCodeQuery(e.target.value);
                  setCodeOpen(true);
                }}
                onFocus={() => setCodeOpen(true)}
                onBlur={() => setTimeout(() => setCodeOpen(false), 120)}
              />

              {codeOpen && (
                <div
                  className="editFailedRule-suggestions"
                  onScroll={handleTriggerCodeSuggestionsScroll}
                >
                  {filteredCodeSuggestions.length === 0 &&
                  triggerCodeLoading ? (
                    <div className="editFailedRule-suggestions-empty editFailedRule-suggestions-loading">
                      <Spinner animation="border" size="sm" className="me-2" />
                      Searching...
                    </div>
                  ) : filteredCodeSuggestions.length === 0 ? (
                    <div className="editFailedRule-suggestions-empty">
                      No matching codes.
                    </div>
                  ) : (
                    <>
                      {filteredCodeSuggestions.map((option) => (
                        <button
                          type="button"
                          key={`${option.code_type}-${option.code}`}
                          className="editFailedRule-suggestion-item"
                          onMouseDown={(e) => {
                            e.preventDefault();
                            addCode(option);
                          }}
                        >
                          <strong>{option.code}</strong>
                          {" — "}
                          {option.description || option.code_description}
                        </button>
                      ))}

                      {triggerCodeLoading && (
                        <div className="editFailedRule-suggestions-empty editFailedRule-suggestions-loading">
                          <Spinner
                            animation="border"
                            size="sm"
                            className="me-2"
                          />
                          Loading more...
                        </div>
                      )}
                    </>
                  )}
                </div>
              )}

              {triggerCodes.length > 0 && (
                <div className="editFailedRule-code-chips">
                  {triggerCodes.map((c) => (
                    <Tooltip
                      key={c.code}
                      title={c.code_description || c.description || c.code}
                      arrow
                      placement="top"
                    >
                      <span className="editFailedRule-code-chip">
                        {c.code}

                        <button
                          type="button"
                          className="editFailedRule-code-chip-remove"
                          aria-label={`Remove ${c.code}`}
                          onClick={() => removeCode(c.code)}
                        >
                          &#215;
                        </button>
                      </span>
                    </Tooltip>
                  ))}
                </div>
              )}
            </div>
          </div>

          {/* Guidance & Decision Support */}
          <div className="editFailedRule-section">
            <div className="editFailedRule-section-header">
              Guidance &amp; Decision Support
            </div>
            <div className="editFailedRule-section-divider" />

            <label className="editFailedRule-label">Configured Guidance</label>
            <textarea
              className="editFailedRule-textarea"
              rows={2}
              value={configuredGuidance}
              onChange={(e) => setConfiguredGuidance(e.target.value)}
            />

            <label className="editFailedRule-label editFailedRule-label--spaced">
              Recommended Action
            </label>
            <textarea
              className="editFailedRule-textarea"
              rows={2}
              value={recommendedAction}
              onChange={(e) => setRecommendedAction(e.target.value)}
            />
          </div>
        </div>

        {/* Footer */}
        <div className="editFailedRule-footer">
          <button
            type="button"
            className="editFailedRule-btn editFailedRule-btn--ghost"
            onClick={handleCancel}
          >
            Cancel
          </button>
          <button
            type="button"
            className="editFailedRule-btn editFailedRule-btn--primary"
            onClick={handleSaveAndTest}
          >
            Save and Test
          </button>
        </div>
      </div>
    </div>
  );
}